
export const OWN = "Own_commission_fee_invoices";
export const RECEIVED = "Received_commission_fee_invoices";
export const CONSOLIDATED = "Own_consolidated_invoices";
